module.exports = __webpack_public_path__ + "static/media/contact_mail_white_24dp.3a4f9513.svg";